$(document).ready(function(){
    function clearinputs(formid){
		$(formid+' .has-feedback').removeClass('has-error has-success'); // remove the error class
		$(formid+' .help-block').remove(); 
	}
    $("#imagefile").on("change",function(){
        if($(this)[0].files[0]){
            $("#preview").remove();
            var files=$(this)[0].files;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                var imageType = /^image\//;
                    
                if (!imageType.test(file.type)) {
                    continue;
                }
                
                var img = document.createElement("img");
                img.classList.add("user-image");
                img.file = file;
                $(this).after("<div id='preview' class='text-center'></div>");
                $("#preview").html(img).addClass("spacetop"); // Assuming that "preview" is the div output where the content will be displayed.
                
                var reader = new FileReader();
                reader.onload = (function(aImg) { return function(e) { aImg.src = e.target.result; }; })(img);
                reader.readAsDataURL(file);
            }
        }
        
    });
    function ajax_login(somedata,that){
        console.log(somedata);
        $.ajax({
            type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
            url         : 'register.php', // the url where we want to POST
            data        : somedata, // our data object
            dataType    : 'json', // what type of data do we expect back from the server
    //	encode      : true,
            contentType : false,
            processData : false
        })
            // using the done promise callback
        .done(function(data) {
            // log data to the console so we can see
            console.log(data); 
            var name_div=that.children("div:nth-child(1)");
            var email_div=that.children("div:nth-child(2)");
            var pwd_div=that.children("div:nth-child(3)");
            var pwdmatch_div=that.children("div:nth-child(4)");
            var msg_block=$("#msg");
            var help_block=that.children(".help-block");
            var img_block=that.find(".form-group:nth-child(5)");
            // here we will handle errors and validation messages
            if ( ! data.success) {
                // handle errors for email ---------------
                if (data.errors.name) {
                    help_block.remove(); // remove the error text
                    name_div.addClass('has-error'); // add the error class to show red input
                    msg_block.append('<div class="help-block"><span class="text-danger">' + data.errors.name + '</span></div>'); // add the actual error message under our input
                }
                if (data.errors.email) {
                    help_block.remove(); // remove the error text
                    email_div.addClass('has-error'); // add the error class to show red input
                    msg_block.append('<div class="help-block"><span class="text-danger">' + data.errors.email + '</span></div>'); // add the actual error message under our input
                }
                if (data.errors.pwd) {
                    help_block.remove(); // remove the error text
                    pwd_div.addClass('has-error'); // add the error class to show red input
                    msg_block.append('<div class="help-block"><span class="text-danger">' + data.errors.pwd + '</span></div>'); // add the actual error message under our input
                }
                if (data.errors.pwdmatch) {
                    help_block.remove(); // remove the error text
                    pwd_div.addClass('has-error'); // add the error class to show red input
                    pwdmatch_div.addClass('has-error'); // add the error class to show red input
                    msg_block.append('<div class="help-block"><span class="text-danger">' + data.errors.pwdmatch + '</span></div>'); // add the actual error message under our input
                }
                if (data.errors.conn) {
                    help_block.remove(); // remove the error text
                    msg_block.append('<div class="help-block"><span class="text-danger">' + data.errors.conn + '</span></div>'); // add the actual error message under our input
                }
                $("#orfb").fadeIn("slow");
            } else {
                help_block.remove(); // remove the error text
                // ALL GOOD! just show the success message!
                email_div.addClass('has-success');
                email_div.append('<div class="help-block nomargin"><span class="text-success">A confirmation email has been sent.</span></div>');
                msg_block.append('<div class="help-block"><span class="text-success">' + data.message + '</span></div>');
                if(data.image){
                    console.log(img_block);
                    img_block.html('<div class="help-block text-center"><img src="../dist/img/users/'+data.image+'" class="user-image center" alt="User Image" width="90" /></div>');
                }
                that.find("input[type=password]").val("");
                // usually after form submission, you'll want to redirect
                // redirect a user to another page
                alertify.success("A confirmation email has been sent."); // for now we'll just alert the user
                var timing=setTimeout(function(){
                	location.href="../login/?registration=1";
                },3000);
            }
        })    
            // using the fail promise callback
        .fail(function(data) {
            $("#orfb").fadeIn("slow");
            alertify.alert(data.responseText).setHeader("Something Broke");
        });
    }
    $('#reg_form').submit(function(event) {
		    event.preventDefault();
            var that=$(this);
			clearinputs('#reg_form');
			// get the form data
			// there are many ways to get this data using jQuery (you can use the class or id also)
			var formData = new FormData($(this)[0]);
            ajax_login(formData,that);
		// stop the form from submitting the normal way and refreshing the page
		
	});        
  
    
    $.getScript('//connect.facebook.net/en_US/sdk.js', function(){
        FB.init({
            appId: '1819272264960918',
            version: 'v2.5',
            xfbml : true,
            status : true,
            cookie : true, // enable cookies to allow the server to access the session
            oauth: true // enable OAuth 2.0
        });     
        $('.btn-facebook').removeAttr('disabled');
        // FB.getLoginStatus(function(response) {
        //     statusChangeCallback(response);
        // });
    });
    function statusChangeCallback(response) {
        // The response object is returned with a status field that lets the
        // app know the current login status of the person.
        // Full docs on the response object can be found in the documentation
        // for FB.getLoginStatus().
        var loggedin = {
                callback : function (response){
                    console.log('Successful login for: ' + response.name,response);
                    $('#msg').html('');
                    // var user_info={
                    //     username:response.name,
                    //     user_url :response.link, 
                    //     img_url : response.picture.data.url
                    // }
                    // var user_box=Mustache.render($('#user-template').html(),user_info);
                    
                    var that = $('#reg_form');
                    var formData = new FormData();
                    formData.append("name" , response.name);
                    formData.append("email" , response.email);
                    formData.append("fb_img" , response.picture.data.url);
                    formData.append("fb_id" , response.id);
                    console.log(formData);
                    ajax_login(formData,that);
                }
            };
        if (response.status === 'connected') {
            // Logged into your app and Facebook.
            console.log('Welcome!  Fetching your information.... ');
            $("#orfb").fadeOut("slow");
            var fields={fields:"id,name,email,picture"};
            testAPI("me",fields,loggedin);
        } else if (response.status === 'not_authorized') {
            // The person is logged into Facebook, but not your app.
             $("#orfb").fadeIn("slow");
        } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
             $("#orfb").fadeIn("slow");
        }
    }

        // This function is called when someone finishes with the Login
        // Button.  See the onlogin handler attached to it in the sample
        // code below.
    function checkLoginState() {
        FB.getLoginStatus(function(response) {
            statusChangeCallback(response);
        });
    }
        
    
    function testAPI(id,fields,fn) {
        FB.api(id,fields, function(response) {
            fn.callback(response);
        });
    }
    function logout(){
        alertify.confirm("This action will also log you out of facebook",function(ev){
            FB.logout(function(response) {
                // user is now logged out
                console.log('Logout successful');
                $('#msg').html('You are now logged out');
                $("#orfb").fadeIn("slow");
                $("#user-box").fadeOut().remove();
            });
        }).setHeader("Are you sure?");
    }
    function login(){
        FB.login(function(response) {
            // user is now logged out
            statusChangeCallback(response);
        }, {
            scope: 'email,public_profile', 
            return_scopes: true		
        });	
    }
   
    $("body").on("click",".btn-facebook",function(ev){
		ev.preventDefault();
        login();
    });	
    
    
    
    
    
 
});